import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Armenian() {
  return (
    <ApiCommunityDirectoryPage
      community="Armenian"
      eyebrow="Armenian community guide"
      title="Armenian favorites, businesses, and local essentials in San Antonio."
      
      tags={["Armenian community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Armenian community guide?"
      modalIdPrefix="armenian-directory"
    />
  );
}
